import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-store-product-detail',
  templateUrl: './store-product-detail.component.html',
  styleUrls: ['./store-product-detail.component.sass']
})
export class StoreProductDetailComponent implements OnInit {
  touroperatorDocId;
  touroperatorDoc;

  storeproductDocId;
  storeproductDoc;
  pictureCol;

  itineraryCol;
  
  coverPhoto: string = "./assets/img/no-cover.png";
  profilePhoto: string = "./assets/img/no-logo.png";
  //email: string = 'moses@pngl.com';

  logoImage: string = "./assets/img/no-logo.png";
  coverImage: string = "./assets/img/no-cover.png";
  

  constructor(
    public db: FirestoreService,
    public route: Router,
    public aroute: ActivatedRoute
    ) {}

  ngOnInit(): void {
    this.storeproductDocId = this.aroute.snapshot.paramMap.get('id');
    this.storeproductDoc = this.db.getMainDoc('storeproducts', this.storeproductDocId); 
    this.pictureCol = this.db.getSubCol('storeproducts', this.storeproductDocId, 'productPictures');
    //console.log(this.pictureCol);
    this.db.getDocId('storeproducts', this.storeproductDocId)
    .then(data=>{
      this.touroperatorDocId = data.touroperatorDocId;
      this.touroperatorDoc = this.db.getMainDoc('touroperators', this.touroperatorDocId);
    })
    this.itineraryCol = this.db.getSubCol('storeproducts', this.storeproductDocId, 'itineraries');  
  }

  scrollToTop(){
    this.route.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
    });  
  }
  
  reloadComponent() {
    let currentUrl = this.route.url;
    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
    this.route.onSameUrlNavigation = 'reload';
    this.route.navigate([currentUrl]);
  }

  routeToDetailPage(docId){
    this.route.navigateByUrl('storeproduct/'+docId);
  };

}
